import React from 'react';

export default function PrivacyPolicy({ onBack }) {
  return (
    <div style={{
      fontFamily: "'Montserrat', sans-serif",
      background: '#0a1628',
      minHeight: '100vh',
      color: '#fff',
      position: 'relative',
      paddingTop: 'env(safe-area-inset-top)',
      paddingBottom: 'env(safe-area-inset-bottom)',
      paddingLeft: 'env(safe-area-inset-left)',
      paddingRight: 'env(safe-area-inset-right)'
    }}>
      {/* Back Button */}
      <button
        onClick={onBack}
        style={{
          position: 'fixed',
          top: 'calc(40px + env(safe-area-inset-top))',
          left: 'calc(40px + env(safe-area-inset-left))',
          background: 'none',
          border: '1px solid rgba(198,162,91,0.4)',
          color: '#c6a25b',
          fontFamily: "'Montserrat', sans-serif",
          fontSize: '1rem',
          letterSpacing: '0.1em',
          textTransform: 'uppercase',
          padding: '12px 24px',
          cursor: 'pointer',
          transition: 'all 0.4s ease-in-out',
          backdropFilter: 'blur(5px)',
          minHeight: '44px',
          zIndex: 100,
          WebkitTapHighlightColor: 'transparent'
        }}
        onMouseOver={(e) => {
          e.currentTarget.style.background = 'rgba(198,162,91,0.15)';
          e.currentTarget.style.borderColor = '#c6a25b';
          e.currentTarget.style.color = '#e6c57e';
        }}
        onMouseOut={(e) => {
          e.currentTarget.style.background = 'none';
          e.currentTarget.style.borderColor = 'rgba(198,162,91,0.4)';
          e.currentTarget.style.color = '#c6a25b';
        }}
      >
        ← Back
      </button>

      {/* Content */}
      <div style={{
        maxWidth: '800px',
        margin: '0 auto',
        padding: '120px 40px 80px',
        boxSizing: 'border-box'
      }}>
        <h1 style={{
          fontFamily: "'Bodoni Moda', serif",
          fontSize: 'clamp(2.5rem, 5vw, 4rem)',
          color: '#e6c57e',
          letterSpacing: '0.05em',
          fontWeight: 400,
          marginBottom: '24px',
          textShadow: '2px 2px 10px rgba(49,35,16,0.5)'
        }}>
          Privacy Policy
        </h1>

        <p style={{ marginBottom: '6px', fontSize: '0.95rem', color: '#b4bad0' }}>
          <strong>Effective Date:</strong> November 15, 2025
        </p>
        <p style={{ marginBottom: '24px', fontSize: '0.95rem', color: '#b4bad0' }}>
          <strong>Last Updated:</strong> November 15, 2025
        </p>

        <div style={{
          fontFamily: "'Montserrat', sans-serif",
          fontSize: '1.05rem',
          lineHeight: 1.8,
          color: '#d4d4d0',
          fontWeight: 300
        }}>
          {/* Introduction */}
          <section style={{ marginBottom: '30px' }}>
            <h2 style={{
              fontFamily: "'Bodoni Moda', serif",
              fontSize: '1.5rem',
              fontWeight: 400,
              letterSpacing: '0.08em',
              textTransform: 'uppercase',
              color: '#e6c57e',
              marginBottom: '10px'
            }}>
              Introduction
            </h2>
            <p style={{ marginBottom: '14px' }}>
              Welcome to Pheme (&quot;we,&quot; &quot;our,&quot; or &quot;us&quot;). We respect your
              privacy and are committed to protecting your personal information. This Privacy Policy
              explains how we collect, use, share, and protect your information when you use our
              mobile application.
            </p>
            <p style={{ marginBottom: '8px' }}>
              Pheme is intended for individuals aged <strong>16 and older</strong>. By using Pheme,
              you confirm that you are at least 16 years old.
            </p>
            <p>
              By using Pheme, you agree to the collection and use of information as described in
              this policy.
            </p>
          </section>

          {/* 1. Information We Collect */}
          <section style={{ marginBottom: '30px' }}>
            <h2 style={{
              fontFamily: "'Bodoni Moda', serif",
              fontSize: '1.5rem',
              fontWeight: 400,
              letterSpacing: '0.08em',
              textTransform: 'uppercase',
              color: '#e6c57e',
              marginBottom: '10px'
            }}>
              1. Information We Collect
            </h2>

            <h3 style={{ fontWeight: 500, marginBottom: '6px', marginTop: '10px' }}>
              Information You Provide Directly
            </h3>
            <ul style={{ paddingLeft: '20px', marginTop: 0, marginBottom: '14px' }}>
              <li style={{ marginBottom: '6px' }}>
                <strong>Account Information:</strong> When you create an account, we collect your
                email address, username, display name, and password (stored in encrypted form).
              </li>
              <li style={{ marginBottom: '6px' }}>
                <strong>Profile Information:</strong> Optional profile bio and profile picture you
                choose to upload.
              </li>
              <li style={{ marginBottom: '6px' }}>
                <strong>User Content:</strong> Photos and images you upload to the app, along with
                any associated captions or text.
              </li>
              <li>
                <strong>Communications:</strong> Information you provide when reporting content or
                contacting support.
              </li>
            </ul>

            <h3 style={{ fontWeight: 500, marginBottom: '6px', marginTop: '10px' }}>
              Information Collected Automatically
            </h3>
            <ul style={{ paddingLeft: '20px', marginTop: 0 }}>
              <li style={{ marginBottom: '6px' }}>
                <strong>Device Information:</strong> Device type, operating system, browser type,
                and device identifiers.
              </li>
              <li style={{ marginBottom: '6px' }}>
                <strong>Usage Data:</strong> How you interact with the app, including photos viewed,
                follow/unfollow actions, and app features used.
              </li>
              <li>
                <strong>Technical Data:</strong> IP address, login times, and app performance data.
              </li>
            </ul>
          </section>

          {/* 2. How We Use Your Information */}
          <section style={{ marginBottom: '30px' }}>
            <h2 style={{
              fontFamily: "'Bodoni Moda', serif",
              fontSize: '1.5rem',
              fontWeight: 400,
              letterSpacing: '0.08em',
              textTransform: 'uppercase',
              color: '#e6c57e',
              marginBottom: '10px'
            }}>
              2. How We Use Your Information
            </h2>
            <p style={{ marginBottom: '10px' }}>We use your information to:</p>
            <ul style={{ paddingLeft: '20px', marginTop: 0 }}>
              <li style={{ marginBottom: '6px' }}>
                <strong>Provide Our Service:</strong> Create and manage your account, display your
                photo feed, enable social features (following, blocking), and deliver core app
                functionality.
              </li>
              <li style={{ marginBottom: '6px' }}>
                <strong>Safety &amp; Moderation:</strong> Scan uploaded images for inappropriate
                content using automated moderation, review user reports, and enforce our community
                guidelines.
              </li>
              <li style={{ marginBottom: '6px' }}>
                <strong>Improve Our Service:</strong> Fix bugs, analyze usage patterns, and enhance
                app features.
              </li>
              <li style={{ marginBottom: '6px' }}>
                <strong>Communications:</strong> Send important updates about your account or the app.
              </li>
              <li>
                <strong>Legal Compliance:</strong> Respond to legal requests and enforce our Terms of
                Service.
              </li>
            </ul>
          </section>

          {/* 3. How We Share Your Information */}
          <section style={{ marginBottom: '30px' }}>
            <h2 style={{
              fontFamily: "'Bodoni Moda', serif",
              fontSize: '1.5rem',
              fontWeight: 400,
              letterSpacing: '0.08em',
              textTransform: 'uppercase',
              color: '#e6c57e',
              marginBottom: '10px'
            }}>
              3. How We Share Your Information
            </h2>

            <h3 style={{ fontWeight: 500, marginBottom: '6px', marginTop: '10px' }}>
              Third-Party Services
            </h3>
            <p style={{ marginBottom: '10px' }}>
              We share data with the following service providers:
            </p>
            <ul style={{ paddingLeft: '20px', marginTop: 0 }}>
              <li style={{ marginBottom: '8px' }}>
                <strong>Supabase (US West - Oregon):</strong> Our backend infrastructure provider
                that hosts your account data, photos, and profiles. Data is stored securely on
                Supabase&apos;s servers located in the United States (Oregon region).
              </li>
              <li style={{ marginBottom: '8px' }}>
                <strong>OpenAI Moderation API:</strong> When you upload a photo, it is sent to
                OpenAI&apos;s content moderation service to automatically detect inappropriate content.
                OpenAI processes the image according to their privacy policy but does not store
                uploaded images permanently for moderation purposes.
              </li>
              <li>
                <strong>Apple Services:</strong> If you use Sign in with Apple or download the app
                from the App Store, Apple may collect certain analytics data according to their
                privacy policy.
              </li>
            </ul>

            <h3 style={{ fontWeight: 500, marginBottom: '6px', marginTop: '14px' }}>
              Public Information
            </h3>
            <ul style={{ paddingLeft: '20px', marginTop: 0 }}>
              <li style={{ marginBottom: '6px' }}>
                Your profile (username, display name, bio, profile picture) and uploaded photos are
                visible to other users of the app.
              </li>
              <li>
                Users you haven&apos;t blocked can view your public content.
              </li>
            </ul>

            <h3 style={{ fontWeight: 500, marginBottom: '6px', marginTop: '14px' }}>
              Legal Requirements
            </h3>
            <p>
              We may disclose your information if required by law, court order, or to protect the
              rights and safety of our users.
            </p>
          </section>

          {/* 4. Data Security */}
          <section style={{ marginBottom: '30px' }}>
            <h2 style={{
              fontFamily: "'Bodoni Moda', serif",
              fontSize: '1.5rem',
              fontWeight: 400,
              letterSpacing: '0.08em',
              textTransform: 'uppercase',
              color: '#e6c57e',
              marginBottom: '10px'
            }}>
              4. Data Security
            </h2>
            <p style={{ marginBottom: '10px' }}>
              We take security seriously and implement industry-standard measures:
            </p>
            <ul style={{ paddingLeft: '20px', marginTop: 0 }}>
              <li style={{ marginBottom: '6px' }}>
                <strong>Encryption:</strong> All data transmitted between your device and our servers
                uses HTTPS encryption.
              </li>
              <li style={{ marginBottom: '6px' }}>
                <strong>Password Protection:</strong> Passwords are encrypted and never stored in plain
                text.
              </li>
              <li style={{ marginBottom: '6px' }}>
                <strong>Secure Authentication:</strong> We use JWT tokens for secure API authentication.
              </li>
              <li>
                <strong>Infrastructure Security:</strong> Supabase provides enterprise-grade security
                for stored data.
              </li>
            </ul>
            <p style={{ marginTop: '10px' }}>
              However, no system is 100% secure. You are responsible for keeping your account
              credentials confidential.
            </p>
          </section>

          {/* 5. Your Rights & Choices */}
          <section style={{ marginBottom: '30px' }}>
            <h2 style={{
              fontFamily: "'Bodoni Moda', serif",
              fontSize: '1.5rem',
              fontWeight: 400,
              letterSpacing: '0.08em',
              textTransform: 'uppercase',
              color: '#e6c57e',
              marginBottom: '10px'
            }}>
              5. Your Rights &amp; Choices
            </h2>
            <p style={{ marginBottom: '10px' }}>
              You have control over your data:
            </p>
            <ul style={{ paddingLeft: '20px', marginTop: 0 }}>
              <li style={{ marginBottom: '6px' }}>
                <strong>Access:</strong> View your profile and account information within the app.
              </li>
              <li style={{ marginBottom: '6px' }}>
                <strong>Modification:</strong> Update your profile picture, bio, display name, and
                other profile information at any time.
              </li>
              <li style={{ marginBottom: '6px' }}>
                <strong>Account Deletion:</strong> Delete your account at any time through the app
                settings. When you delete your account, we permanently remove:
                <ul style={{ paddingLeft: '20px', marginTop: '6px' }}>
                  <li>Your profile information</li>
                  <li>All photos you&apos;ve uploaded</li>
                  <li>Your follow relationships</li>
                  <li>Your account credentials</li>
                </ul>
                <span style={{ display: 'block', marginTop: '6px' }}>
                  Note: Deletion may take up to 30 days to complete. Some data may be retained if
                  required by law.
                </span>
              </li>
              <li>
                <strong>Blocking:</strong> Block other users to prevent them from viewing your content
                or interacting with you.
              </li>
            </ul>
          </section>

          {/* 6. Data Retention */}
          <section style={{ marginBottom: '30px' }}>
            <h2 style={{
              fontFamily: "'Bodoni Moda', serif",
              fontSize: '1.5rem',
              fontWeight: 400,
              letterSpacing: '0.08em',
              textTransform: 'uppercase',
              color: '#e6c57e',
              marginBottom: '10px'
            }}>
              6. Data Retention
            </h2>
            <ul style={{ paddingLeft: '20px', marginTop: 0 }}>
              <li style={{ marginBottom: '6px' }}>
                <strong>Active Accounts:</strong> We retain your data while your account is active.
              </li>
              <li style={{ marginBottom: '6px' }}>
                <strong>Deleted Accounts:</strong> After you delete your account, data is permanently
                removed within 30 days unless we&apos;re required to retain it for legal reasons.
              </li>
              <li>
                <strong>Backups:</strong> Data in automated backups may persist for up to 90 days after
                deletion.
              </li>
            </ul>
          </section>

          {/* 7. Children's Privacy (16+) */}
          <section style={{ marginBottom: '30px' }}>
            <h2 style={{
              fontFamily: "'Bodoni Moda', serif",
              fontSize: '1.5rem',
              fontWeight: 400,
              letterSpacing: '0.08em',
              textTransform: 'uppercase',
              color: '#e6c57e',
              marginBottom: '10px'
            }}>
              7. Children&apos;s Privacy
            </h2>
            <p style={{ marginBottom: '10px' }}>
              Pheme is <strong>not intended</strong> for users under the age of <strong>16</strong>.
              We do not knowingly collect personal information from children under 16. If we discover
              that a child under 16 has provided us with personal information, we will delete that
              account and information immediately.
            </p>
            <p>
              If you believe a child has created an account, please contact us at{' '}
              <a href="mailto:amishabansal21@gmail.com" style={{ color: '#e6c57e' }}>
                amishabansal21@gmail.com
              </a>.
            </p>
          </section>

          {/* 8. International Data Transfers */}
          <section style={{ marginBottom: '30px' }}>
            <h2 style={{
              fontFamily: "'Bodoni Moda', serif",
              fontSize: '1.5rem',
              fontWeight: 400,
              letterSpacing: '0.08em',
              textTransform: 'uppercase',
              color: '#e6c57e',
              marginBottom: '10px'
            }}>
              8. International Data Transfers
            </h2>
            <p style={{ marginBottom: '10px' }}>
              Your information may be transferred to and stored on servers located outside your
              country. By using our app, you consent to the transfer of your information to the
              United States (Oregon) where our servers are located. We ensure appropriate safeguards
              are in place to protect your data in compliance with applicable laws.
            </p>
            <p>
              <strong>For EU Users:</strong> We comply with GDPR requirements and use standard
              contractual clauses for international data transfers.
            </p>
          </section>

          {/* 9. Content Moderation */}
          <section style={{ marginBottom: '30px' }}>
            <h2 style={{
              fontFamily: "'Bodoni Moda', serif",
              fontSize: '1.5rem',
              fontWeight: 400,
              letterSpacing: '0.08em',
              textTransform: 'uppercase',
              color: '#e6c57e',
              marginBottom: '10px'
            }}>
              9. Content Moderation
            </h2>

            <h3 style={{ fontWeight: 500, marginBottom: '6px', marginTop: '10px' }}>
              Automated Moderation
            </h3>
            <p style={{ marginBottom: '6px' }}>
              All uploaded photos are automatically scanned using OpenAI&apos;s moderation API to
              detect potentially inappropriate content such as:
            </p>
            <ul style={{ paddingLeft: '20px', marginTop: 0 }}>
              <li>Violence or graphic content</li>
              <li>Adult/sexual content</li>
              <li>Hate symbols or offensive imagery</li>
            </ul>
            <p style={{ marginTop: '10px' }}>
              If your photo is flagged, you&apos;ll receive a notification and the photo won&apos;t
              be published.
            </p>

            <h3 style={{ fontWeight: 500, marginBottom: '6px', marginTop: '14px' }}>
              User Reports
            </h3>
            <p style={{ marginBottom: '6px' }}>
              Users can report content they believe violates our guidelines. Reports are reviewed
              manually, and we may:
            </p>
            <ul style={{ paddingLeft: '20px', marginTop: 0 }}>
              <li>Remove the reported content</li>
              <li>Issue warnings</li>
              <li>Suspend or terminate accounts for repeated violations</li>
            </ul>
          </section>

          {/* 10. Camera & Photo Library Access */}
          <section style={{ marginBottom: '30px' }}>
            <h2 style={{
              fontFamily: "'Bodoni Moda', serif",
              fontSize: '1.5rem',
              fontWeight: 400,
              letterSpacing: '0.08em',
              textTransform: 'uppercase',
              color: '#e6c57e',
              marginBottom: '10px'
            }}>
              10. Camera &amp; Photo Library Access
            </h2>
            <p style={{ marginBottom: '10px' }}>
              Pheme requests access to your device&apos;s camera and photo library to enable you to:
            </p>
            <ul style={{ paddingLeft: '20px', marginTop: 0 }}>
              <li style={{ marginBottom: '6px' }}>Take photos directly in the app</li>
              <li>Select photos from your gallery to upload</li>
            </ul>
            <p style={{ marginTop: '10px' }}>
              You can deny these permissions, but you won&apos;t be able to upload photos. We don&apos;t
              access your camera or photo library without your explicit permission.
            </p>
          </section>

          {/* 11. Content Ownership & License */}
          <section style={{ marginBottom: '30px' }}>
            <h2 style={{
              fontFamily: "'Bodoni Moda', serif",
              fontSize: '1.5rem',
              fontWeight: 400,
              letterSpacing: '0.08em',
              textTransform: 'uppercase',
              color: '#e6c57e',
              marginBottom: '10px'
            }}>
              11. Content Ownership &amp; License
            </h2>
            <ul style={{ paddingLeft: '20px', marginTop: 0 }}>
              <li style={{ marginBottom: '6px' }}>
                You retain full ownership of the photos and content you upload.
              </li>
              <li style={{ marginBottom: '6px' }}>
                By uploading content, you grant us a license to display it within the app and use it
                for content moderation purposes.
              </li>
              <li>
                You represent that you have the right to upload and share the content you post.
              </li>
            </ul>
          </section>

          {/* 12. Cookies & Tracking Technologies */}
          <section style={{ marginBottom: '30px' }}>
            <h2 style={{
              fontFamily: "'Bodoni Moda', serif",
              fontSize: '1.5rem',
              fontWeight: 400,
              letterSpacing: '0.08em',
              textTransform: 'uppercase',
              color: '#e6c57e',
              marginBottom: '10px'
            }}>
              12. Cookies &amp; Tracking Technologies
            </h2>
            <p style={{ marginBottom: '10px' }}>
              We use essential cookies and similar technologies for:
            </p>
            <ul style={{ paddingLeft: '20px', marginTop: 0 }}>
              <li style={{ marginBottom: '6px' }}>Authentication sessions</li>
              <li style={{ marginBottom: '6px' }}>App functionality and preferences</li>
              <li>Security features</li>
            </ul>
            <p style={{ marginTop: '10px' }}>
              We do not use tracking cookies for advertising or cross-app tracking.
            </p>
          </section>

          {/* 13. Changes to This Privacy Policy */}
          <section style={{ marginBottom: '30px' }}>
            <h2 style={{
              fontFamily: "'Bodoni Moda', serif",
              fontSize: '1.5rem',
              fontWeight: 400,
              letterSpacing: '0.08em',
              textTransform: 'uppercase',
              color: '#e6c57e',
              marginBottom: '10px'
            }}>
              13. Changes to This Privacy Policy
            </h2>
            <p style={{ marginBottom: '10px' }}>
              We may update this Privacy Policy from time to time. When we make changes, we&apos;ll:
            </p>
            <ul style={{ paddingLeft: '20px', marginTop: 0 }}>
              <li style={{ marginBottom: '6px' }}>
                Update the &quot;Last Updated&quot; date at the top
              </li>
              <li style={{ marginBottom: '6px' }}>
                Notify you through the app or via email
              </li>
              <li>
                Give you an opportunity to review the changes
              </li>
            </ul>
            <p style={{ marginTop: '10px' }}>
              Continued use of the app after changes means you accept the updated policy.
            </p>
          </section>

          {/* 14. Contact Us */}
          <section style={{ marginBottom: '26px' }}>
            <h2 style={{
              fontFamily: "'Bodoni Moda', serif",
              fontSize: '1.5rem',
              fontWeight: 400,
              letterSpacing: '0.08em',
              textTransform: 'uppercase',
              color: '#e6c57e',
              marginBottom: '10px'
            }}>
              14. Contact Us
            </h2>
            <p style={{ marginBottom: '6px' }}>
              If you have questions about this Privacy Policy or how we handle your data, contact us at:
            </p>
            <p style={{ marginBottom: '4px' }}>
              <strong>Email:</strong>{' '}
              <a href="mailto:amishabansal21@gmail.com" style={{ color: '#e6c57e' }}>
                amishabansal21@gmail.com
              </a>
            </p>
            <p style={{ marginBottom: '4px' }}>
              <strong>Location:</strong> Los Angeles, California, USA
            </p>
            <p>
              <strong>Response Time:</strong> We aim to respond within 7 business days.
            </p>
          </section>

          <hr style={{ borderColor: 'rgba(158,164,184,0.3)', margin: '18px 0' }} />

          <section>
            <p style={{ marginBottom: '4px', fontWeight: 500 }}>Your Privacy Matters</p>
            <p>
              We&apos;re committed to transparency and protecting your information. Thank you for
              trusting Pheme.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
